import ReactPixel from "react-facebook-pixel";
import { initGA } from "./ga";
import ReactGTM from "react-gtm-module";
const getAnaliticsConfigByFacility = {
  "273": { pixelId: "1232725160738501", gaId: "G-NRHETLWQFK" },
  "1224": { pixelId: "913533666380507", GTM: "GTM-WJBCZSD" },
  "1204": { pixelId: "777232707357603" },
  "1200": { pixelId: "1637422596662010" },
  "1227": { pixelId: "885648790025244", gaId: "G-Q16RVEQD1D" },
  "1214": { pixelId: "", GTM: "GTM-T4LHX4S" },
  "1240": { pixelId: "", gaId: "G-5YRNL6YTS5" },
  "1241": { pixelId: "1737692646444566", GTM: "GTM-NZT9RJ" },
  "1243": { pixelId: "1737692646444566", GTM: "GTM-NZT9RJ" },
  "1212": { pixelId: "", GTM: "GTM-NFXDL5WJ" },
  "1196": { pixelId: "", GTM: "GTM-MFSPN897" },
  "1249": { pixelId: "806842736358213" },
  "1253": { pixelId: "1518446349936606", GTM: "GTM-PFGLPWGX" },
};

const advancedMatching = { ct: "", country: "", db: "", em: "", fn: "", ge: "", ln: "", ph: "", st: "", zp: "" };

const options = {
  autoConfig: true,
  debug: false,
};

// Type guard to check if gaId exists in config and is not empty
function hasGaId(config: { pixelId: string; gaId?: string }): config is { pixelId: string; gaId: string; GTM: string } {
  return "gaId" in config && !!config.gaId;
}

// Sprawdza, czy obiekt konfiguracji ma `GTM`
function hasGTM(config: { pixelId: string; gaId?: string; GTM?: string }): config is { pixelId: string; GTM: string } {
  return !!config.GTM;
}

export const initializeAnaliticsByFacility = (facilityIds: string) => {
  if (facilityIds in getAnaliticsConfigByFacility) {
    const config = getAnaliticsConfigByFacility[facilityIds as keyof typeof getAnaliticsConfigByFacility];
    if (config) {
      console.info("Analytics has been successfully initialized");
      // Inicjalizacja Facebook Pixel
      ReactPixel.init(config.pixelId, advancedMatching, options);

      // Inicjalizacja Google Analytics (jeśli jest dostępny gaId)
      if (hasGaId(config)) {
        initGA(config.gaId);
      }

      // Inicjalizacja Google Tag Manager
      if (hasGTM(config)) {
        ReactGTM.initialize({ gtmId: config.GTM });
      }
    }
  }
};

export const canSendToGA = (facilityId: string): boolean => {
  const config = getAnaliticsConfigByFacility[facilityId as keyof typeof getAnaliticsConfigByFacility];
  return !!config && hasGaId(config);
};

export const canSendToFacebookPixel = (facilityId: string): boolean => {
  const config = getAnaliticsConfigByFacility[facilityId as keyof typeof getAnaliticsConfigByFacility];
  return !!config && !!config.pixelId;
};

export const canSendToGTM = (facilityId: string): boolean => {
  const config = getAnaliticsConfigByFacility[facilityId as keyof typeof getAnaliticsConfigByFacility];
  return !!config && hasGTM(config);
};
